var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234.56 170.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#424240;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.53,74.58h78q53,0,105.93,0a26.44,26.44,0,0,1,6.42.59,10.05,10.05,0,0,1,7.72,10.3,10.37,10.37,0,0,1-7.56,10,22.56,22.56,0,0,1-6.94.58H36.83c1.76,1.85,2.81,3,3.92,4.12Q66,125.44,91.29,150.68c2.15,2.15,4.1,4.35,4.46,7.55.52,4.58-1,8.27-5,10.62a10,10,0,0,1-11.7-.52A29.92,29.92,0,0,1,75.42,165q-35-35-70-69.94c-7.3-7.3-7.28-12.11.08-19.46Q41,40,76.52,4.51c3.77-3.79,7.86-5.65,13-3.77,7.39,2.72,8.91,11.94,2.89,18C79.29,32,66.06,45.18,52.86,58.36,47.73,63.48,42.58,68.57,36.53,74.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.eb106409aef7f2c1c0c5c05de7852f38.svg";
export { ForwardRef as ReactComponent };